import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type SummaryCardVariant = 'warning' | 'primary' | 'success' | 'danger' | 'info';

@Component({
    selector: 'app-summary-card',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './summary-card.component.html',
    styleUrls: ['./summary-card.component.scss'],
})
export class SummaryCardComponent {
    @Input() variant: SummaryCardVariant = 'primary';
    @Input() tag = '';
    @Input() icon = '';
    @Input() value: number | string = 0;
    @Input() unit = '';
    @Input() title = '';
    @Input() subtext = '';
    @Input() active = false;
}
